import { api } from './';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const editarCabecalho = async (params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put(`/cabecalho/editar`, params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    // Backend agora sempre retorna JSON estruturado, usar o message
    const errorMessage = apiError.response?.data?.message || 'Erro ao editar cabeçalho';
    throw new Error(errorMessage);
  }
};

export const obterCabecalho = async () => {
  try {
    const response = await api.get(`/cabecalho/obter`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter cabeçalho';
    throw new Error(errorMessage);
  }
};

export const inserirCabecalhoNoCdn = async (params: FormData) => {
  try {
    const response = await api.post('/files/upload', params, {
      headers: {
        'Accept': '*/*'
      },
    });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao fazer upload do arquivo';
    throw new Error(errorMessage);
  }
};

export const editarCabecalhoNoCdn = async (params: FormData) => {
  try {
    const response = await api.put('/files/update', params, {
      headers: {
        'Accept': '*/*'
      },
    });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const deletarCabecalhoImagem = async (folderName: string, fileName: string ) => {
  try {
    const response = await api.delete(`/files/${folderName}/${fileName}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao deletar mídia do CDN';
    throw new Error(errorMessage);
  }
};